import { toJS } from "mobx";
import { TableFornecedores } from "../components";
import { useStores } from "../components/contexts/store-provider.context";
import LayoutDashboard from "../components/layout/LayoutDashboard.component";
import { useFornecedores } from "../services";
import { memoObserver } from "../utils/memoObserver.utils";
import { useEffect } from "react";

export const Fornecedores = memoObserver(() => {
  const { getFornecedores } = useFornecedores();
  const { fornecedoresStore } = useStores();

  useEffect(() => {
    getFornecedores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LayoutDashboard>
      <TableFornecedores
        loading={fornecedoresStore.loading}
        data={toJS(fornecedoresStore.data) || []}
      />
    </LayoutDashboard>
  );
});
